import React from 'react'
import { useIntl } from 'react-intl'
import { PATH_IMAGES_CDN } from 'src/constants/environment'

import Image from 'src/comps/Image'
import { affiliateHasLogo } from 'src/comps/Affiliate/functions'

import styles from './styles.module.css'

const Affiliate = ({ id, className }: { id?: string; className?: string }) => {
  const intl = useIntl()
  if (!affiliateHasLogo(id)) {
    return null
  }

  return (
    <div className={`${styles.affiliateBase} ${className}`}>
      <span>{intl.formatMessage({ id: 'global.found-on' })}</span>
      <Image
        alt={`${id}-logo`}
        layout="cover"
        src={`${PATH_IMAGES_CDN}/affiliates/160524-aid-${id}.svg`}
      />
    </div>
  )
}

export default Affiliate
